import env from '../app/env';
import { setupClient as setupClientAbisko } from '@svt/abtest/client';
import { device } from 'app/ui-components/breakpoints';

const error = require('debug')('play:client:abisko:error');
const debug = require('debug')('play:client:abisko:debug');

let resolveWaitForAbiskoSetup;
let rejectWaitForAbiskoSetup;

export const waitForAbiskoSetup = new Promise((resolve, reject) => {
    resolveWaitForAbiskoSetup = resolve;
    rejectWaitForAbiskoSetup = reject;
});

let setupAbisko;

if (env.FLAG_ENABLE_ABISKO) {
    const isIE11 =
        typeof window !== 'undefined' &&
        Boolean(window.MSInputMethodContext) &&
        Boolean(document.documentMode);
    let isMobile = false;
    let isMobileLandscape = false;

    if (typeof window !== 'undefined') {
        const match = window.matchMedia(`${device.GteSmall}`);
        isMobile = !match.matches;
        const landscapeMatch = window.matchMedia(`(orientation: landscape) and (min-height: 600px)`);
        isMobileLandscape = !landscapeMatch.matches;
    }

    setupAbisko = (store) =>
        setupClientAbisko({
            projectId: 'svtplay',
            environment: env.ABISKO_ENVIRONMENT,
            networkTimeout: env.ABISKO_CLIENT_TIMEOUT,
            reduxStore: store,
            showDebugInfo: env.IS_DEVELOPMENT,
            clientSideAllocations: true,
            platform: 'web',
            experimentsConfig: {
                // Configuration object for specific experiment overrides
                // ['search-grid-experiment']: {
                //     // ignoreNewUsers: true, // If true: Will ignore tests if user has no allocations stored in cookie but will allocate on client
                //     disabled: isIE11,
                // },

                // eslint-disable-next-line no-useless-computed-key
                ['episode-picker']: {
                    disabled: isIE11 || isMobile || isMobileLandscape,
                },
            },
        })
            .then(({ projectId, activeExperiments, activeAllocations }) => {
                debug('setupAbiskoClient', {
                    projectId,
                    activeExperiments,
                    activeAllocations,
                });
                resolveWaitForAbiskoSetup && resolveWaitForAbiskoSetup();
            })
            .catch((e) => {
                error('Got an error from a/bisko', e);
                rejectWaitForAbiskoSetup && rejectWaitForAbiskoSetup();
            });
} else {
    setupAbisko = () => Promise.resolve();
    resolveWaitForAbiskoSetup();
}

export default setupAbisko;
